module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-bulb-2be435552a5da5ab6b621eb2c8ce0760.svg";